import { render, staticRenderFns } from "./ExtendAdd.vue?vue&type=template&id=a0b8470e&scoped=true&"
import script from "./ExtendAdd.vue?vue&type=script&lang=js&"
export * from "./ExtendAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b8470e",
  null
  
)

export default component.exports